export const addEvents = (obj, typelist, fn) => {
	if (obj.addEventListener) {
		typelist.forEach((type) => {
			obj.addEventListener(type, fn, false);
		});
	} else if (obj.attachEvent) {
		typelist.forEach((type) => {
			obj['e' + type + fn] = fn;
			obj[type + fn] = function () {
				obj['e' + type + fn](window.event);
			};
			obj.attachEvent('on' + type, obj[type + fn]);
		});
	} else {
		typelist.forEach((type) => {
			obj['on' + type] = obj['e' + type + fn];
		});
	}
};
